import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comp_form_small = _resolveComponent("comp-form-small")!
  const _component_comp_model = _resolveComponent("comp-model")!

  return (_openBlock(), _createBlock(_component_comp_model, {
    ref: "form_model",
    title: _ctx.title,
    height: "auto",
    width: _ctx.width,
    onOnClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_comp_form_small, {
          ref: "form",
          structure: _ctx.formStructure,
          submitApi: _ctx.formSubmitApi,
          detailUrl: _ctx.detailUrl,
          onOnSubmit: _ctx.onSubmit
        }, null, 8, ["structure", "submitApi", "detailUrl", "onOnSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["title", "width", "onOnClose"]))
}